// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAdcrv5bWOjO4yN0sS3t4HiszckYyWpgvA",
  authDomain: "textdrip-gvm.firebaseapp.com",
  projectId: "textdrip-gvm",
  storageBucket: "textdrip-gvm.firebasestorage.app",
  messagingSenderId: "892316953404",
  appId: "1:892316953404:web:e4a80605a2e4decbc00c39",
  measurementId: "G-83SYQLCKP4",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
